import { render, staticRenderFns } from "./CaptiveFormsList.vue?vue&type=template&id=60722ca9&scoped=true"
import script from "./CaptiveFormsList.vue?vue&type=script&lang=js"
export * from "./CaptiveFormsList.vue?vue&type=script&lang=js"
import style0 from "./CaptiveFormsList.vue?vue&type=style&index=0&id=60722ca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60722ca9",
  null
  
)

export default component.exports